import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

import { Heading1 } from './components/h1';
import { Heading2 } from './components/h2';
import { Heading3 } from './components/h3';
import { Heading4 } from './components/h4';
import { Paragraph } from './components/p';
import { Bold } from './components/b';
import { Em } from './components/em';
import { Table } from './components/table';
import { Thead } from './components/thead';
import { Tbody } from './components/tbody';
import { Th } from './components/th';
import { Td } from './components/td';
import { Tr } from './components/tr';
import { Ul } from './components/ul';
import { Li } from './components/li';
import { Ol } from './components/ol';
import { A } from './components/a';
import { I } from './components/i';

const components: Components = {
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  h4: Heading4,
  p: Paragraph,
  b: Bold,
  em: Em,
  table: Table,
  thead: Thead,
  tbody: Tbody,
  th: Th,
  td: Td,
  tr: Tr,
  ul: Ul,
  li: Li,
  ol: Ol,
  a: A,
  i: I,
};

export function MarkdownRenderer(props: { markdown: string }) {
  const { markdown } = props;

  return (
    <span className="[&>*]:inline-block [&>*]:w-full">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={components}
      >
        {markdown}
      </ReactMarkdown>
    </span>
  );
}
